import { Button, Flex, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import ActionConfirmationModal from 'src/app/shared/components/modal/action-confirmation-modal'
import { ModalWarningIcon } from 'src/assets/icons'
import './index.scss'

interface IProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  ruleDescription: string
}

const ConfirmModal = (props: IProps) => {
  const { isOpen, onClose, onConfirm, ruleDescription = '' } = props
  const { t } = useTranslation()

  return (
    <ActionConfirmationModal
      icon={<ModalWarningIcon />}
      title={<Typography className='modal-title'>{t('ACHExceptionRule:modal.warning')}</Typography>}
      onClose={onClose}
      isOpen={isOpen}
      descriptionType='string'
      description={
        <Flex>
          <Typography.Text>
            {t('ACHExceptionRule:modal.description1')} <b>{ruleDescription}</b>
            {t('ACHExceptionRule:modal.description2')}
          </Typography.Text>
        </Flex>
      }
      footer={[
        <Button size='middle' type='primary' onClick={onConfirm} key={'yes'}>
          {t('common:ok')}
        </Button>,
      ]}
    />
  )
}

export default ConfirmModal
